import { Navigate, useParams } from 'react-router-dom';

import { useGetCategoryProduct } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveCategoryProduct } from '../../shared/components/saveCategoryProduct';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateCategoryProductPageInterface {}

const UpdateCategoryProductPage: React.FC<UpdateCategoryProductPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_categoria_producto)

  const { id } = useParams();
  const { data, isLoading } = useGetCategoryProduct(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_categoria_producto) return <Navigate to="/inventario/categoria-productos" />;

  return <SaveCategoryProduct titlePage="Editar categorias de productos" editCategoryProduct={data.data} />;
};

export default UpdateCategoryProductPage;
